module.exports = __webpack_public_path__ + "static/media/multi-platform-moduleD1.1ed3792a.png";